
import StepBar from "@/components/stepBar/StepBar.vue";
import DisplayCertificateVue from "@/components/modal/DisplayCertificate.vue";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    StepBar,
    DisplayCertificateVue,
  },
  data() {
    return {
      showDisplayCertificateModal: false,
      previousCertificateExists: false,
      updatePreviousCertificate: false,
      certificateFile: "",
      certificateId: -1,
    };
  },
  methods: {
    passCertificateUpload() {
      this.$router.push({ name: "RegisterPayment" });
    },
    activateUpdateCertificate() {
      this.updatePreviousCertificate = true;
    },
    toggleDisplayCertificateModal() {
      this.showDisplayCertificateModal = !this.showDisplayCertificateModal;
    },
    openCertificateModal(certificateFile: string) {
      this.certificateFile = certificateFile;
      this.toggleDisplayCertificateModal();
    },
    uploadCertificate() {
      if (this.previousCertificateExists && !this.updatePreviousCertificate) {
        this.updateCertificate();
      } else {
        this.createCertificate();
      }
    },
    async findPreviousCertificate() {
      const lastCertificate = await axios.get("certificates/me/last");
      if (lastCertificate.status >= 300) {
        return;
      }
      this.previousCertificateExists = true;
      this.certificateFile = lastCertificate.data.filename;
      this.certificateId = lastCertificate.data.id;
    },
    async updateCertificate() {
      const response = await axios.patch("/certificates/" + this.certificateId);
      if (response.status !== 200) return;
      this.$store.dispatch("user/setMe");
      this.$router.push({ name: "RegisterPayment" });
    },
    async createCertificate() {
      let formData = new FormData();
      let imageFile: HTMLInputElement | null =
        document.querySelector("#inputCertificate");
      if (imageFile && imageFile.files && imageFile.files[0]) {
        formData.append("certificate", imageFile.files[0]);
        formData.append(
          "editionId",
          this.$store.getters["edition/getEditionId"]
        );
        const response = await axios.post("/certificates/upload", formData);
        if (response.status !== 200) return;
        this.$store.dispatch("user/setMe");
        this.$router.push({ name: "RegisterPayment" });
      }
    },
  },
  beforeMount() {
    this.findPreviousCertificate();
  },
});
